module.exports = {"name":"alice","parameters":[{"name":"aliceEnabled","valid":[true,false],"value":false}]}